module.exports = __webpack_public_path__ + "static/media/29@2x.f7fc0ab3.png";